import { render, staticRenderFns } from "./ArticleAiSummary.vue?vue&type=template&id=65a34f22&scoped=true"
import script from "./ArticleAiSummary.vue?vue&type=script&lang=ts"
export * from "./ArticleAiSummary.vue?vue&type=script&lang=ts"
import style0 from "./ArticleAiSummary.vue?vue&type=style&index=0&id=65a34f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a34f22",
  null
  
)

export default component.exports